import { render, staticRenderFns } from "./LocationEditRight.vue?vue&type=template&id=4c546722"
import script from "./LocationEditRight.vue?vue&type=script&lang=js"
export * from "./LocationEditRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports